:host {
  display: block;
  padding: 10px 10px 0 0;
}

.info-icon {
  width: 21px;
  height: 21px;
  display: inline-block;
  fill: #42b4e6;
  vertical-align: middle;
}

.info-text {
  margin-left: 4px;
}

se-link {
  margin-left: -6px;
}

se-link:hover .info-icon {
  fill: #0087cd;
}

iframe {
  width: 0;
  height: 0;
  visibility: hidden;
  border-style: hidden;
}
